
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Inquiry extends Vue{
  iframeWdth;
  iframeHeight;
  footerFixedHeight = 47;
  echatUri = 'https://www.echatsoft.com/visitor/pc/chat.html?companyId=522131';

  created() {
    this.iframeWdth = '100%';
    this.iframeHeight = `${window.innerHeight - this.footerFixedHeight}px`;
  }

}
